const rectalBleeding=[
{ 
        label:"Character:",
        controlType:"checkbox group",
        options:["Fresh blood", "Dark blood"],
        },

        { 
        label:"Relationship to stool:",
        controlType:"checkbox group",
        options:["Mixed with the stool", "Separate from the stool"],
        },


        { 
        label:"Associated anal pain:",
        controlType:"radio button",
        options:["Painful", "Painless"]
        }, 
        
        {
        label:"Frequency",
        controlType:"radio button",
        options:["Every day", "Most days", "Evey week or two", "Occasionally"]
        },

        { 
        label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
    
    ]
    


export default rectalBleeding